const _ = require('./enum');

const status = {
  [_.INIT]: {
    id: _.INIT,
    label: 'Init',
    color: 'blue',
  },
  [_.PENDING]: {
    id: _.PENDING,
    label: 'Pending',
    color: 'orange',
  },
  [_.SUCCESS]: {
    id: _.SUCCESS,
    label: 'Success',
    color: 'green',
  },
  [_.FAILURE]: {
    id: _.FAILURE,
    label: 'Failure',
    color: 'red',
  },
};

module.exports = status;
